import { Component } from "@angular/core";
import { AuthService } from "app/auth/auth.service";
import { IUser } from "app/auth/user.model";
import { IonicPage } from "ionic-angular";
import { NavigationService } from "navigation/navigation.service";
import { commonVar } from "providers/common-var/common";

@IonicPage({
  name: "forgot-password",
  segment: "forgot-password",
})
@Component({
  selector: "forgot-password",
  templateUrl: "./forgot-password.html",
})
export class ForgotPassword {
  emailRegex = commonVar.EMAIL_REGEX;
  loading: boolean;
  user: IUser;
  errorMessage: String;
  errorEmail: String;

  constructor(private authSvc: AuthService, public navSvc: NavigationService) {
    this.loading = false;
    this.user = {} as IUser;
  }
  public forgotPassword(): void {
    this.loading = true;
    // CO-3348: clear the previous attempt's errors before starting a new one —
    // see the identical note in first-time-login.ts. These two pages are
    // line-for-line copies apart from `showForgotMessage`; any change to one
    // belongs in the other.
    this.errorMessage = "";
    this.errorEmail = "";
    if (!this.isEmailValid(this.user.email)) {
      this.errorEmail = "Please enter a valid email";
      this.loading = false;
      return;
    }

    this.authSvc
      .forgotPassword(this.user.email)
      .then(() => {
        this.navSvc.goToInternalPage("reset-password", {
          email: this.user.email,
          showForgotMessage: true,
        });
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        if (error.code === "NotAuthorizedException") {
          this.errorMessage = "Incorrect email. Please try again.";
        } else if (error.code === "UserNotFoundException") {
          this.errorMessage = "Incorrect email. Please try again.";
        } else if (error.code === "UserNotConfirmedException") {
          this.errorMessage =
            "User email is not confirmed. Please confirm your email first.";
        } else if (error.code === "UserAccountDisabledException") {
          this.errorMessage =
            "User account is disabled. Please contact support.";
        } else {
          this.errorMessage =
            "An error occurred while processing your request.";
          if (error.message) {
            this.errorMessage = error.message;
          }
        }
      });
  }

  public backLogin(): void {
    this.navSvc.goToInternalPage("sign-in-page", {});
  }

  isEmailValid(email: string): boolean {
    return this.emailRegex.test(email);
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/cognito/forgot-password-cognito/forgot-password.ts